export function truncateDoubleTo(double, nDec) {
	let ds = double + "";
	let decimalPart = ds.split(".")[1];
	let fixed = "";
	if(decimalPart) {
		for(let i = 0; i < decimalPart.length; i++) {
			fixed = fixed + decimalPart.charAt(i);
			if(fixed.length == nDec) {
				break;
			}
		}	
	}
	while(fixed.length < nDec) {
		fixed += '0';
	}
	return ds.split(".")[0] + "." + fixed;
}
